<template>
  <div class="h-100">
    <div class="d-flex justify-end">
      <v-btn-toggle
        v-model="viewMode"
        mandatory
        :rounded="false"
        variant="outlined">
        <v-btn
          v-tooltip="'Відобразити в форматі дерева'"
          value="tree"
          icon="mdi-sitemap-outline"></v-btn>
        <v-btn
          v-tooltip="'Відобразити в форматі списка'"
          value="table"
          icon="mdi-format-list-bulleted"></v-btn>
      </v-btn-toggle>
    </div>

    <tree-view v-if="viewMode === 'tree'"></tree-view>
    <table-view v-if="viewMode === 'table'"></table-view>
  </div>
</template>

<script lang="ts">
import TreeView from './TreeView.vue'
import TableView from './TableView.vue'
import { ref } from 'vue'
import { initDepartmentList } from './index'

export default {
  name: 'Index',
  components: { TreeView, TableView },
  setup() {
    const viewMode = ref('tree')
    initDepartmentList()

    return { viewMode }
  },
}
</script>

<style scoped lang="scss"></style>
